import { render, staticRenderFns } from "./s.vue?vue&type=template&id=63391d8f&scoped=true&"
import script from "./s.vue?vue&type=script&lang=js&"
export * from "./s.vue?vue&type=script&lang=js&"
import style0 from "./s.vue?vue&type=style&index=0&id=63391d8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63391d8f",
  null
  
)

export default component.exports